import DocumentPaySignContainer from "components/containers/DocumentPaySignContainer/DocumentPaySignContainer";
import React from "react";


function DocumentPaySignRoute(){
  return(
      <DocumentPaySignContainer/>
  );
}

export default DocumentPaySignRoute;
